<template>
  <v-container>
    <h3>担当者情報</h3>
    <v-layout row　align-center>
      <v-spacer />
      <v-flex md3>
        <v-btn @click="addItem">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog">
      <v-card v-if="selectedItem">
        <v-card-title class="headline grey lighten-2" primary-title>担当者情報</v-card-title>
        <v-card-text>
          {{selectedItem}}
          <v-layout row wrap>
            <v-flex md2>
              <v-select :items="['To','Cc']" label="種別" v-model="selectedItem.toOrCc"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4>
              <v-text-field v-model="selectedItem.name" label="名前" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4>
              <v-text-field v-model="selectedItem.email" label="メールアドレス" required></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog=false">閉じる</v-btn>
          <v-btn v-if="action == 'add'" @click="createItem">追加</v-btn>
          <v-btn v-if="action == 'update'" @click="updateItem">更新</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :items="contacts" :headers="headers" hide-actions class="elevation-1" no-data-text="登録されてません。">
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.toOrCc}}</td>
          <td>{{props.item.name}}</td>
          <td>{{props.item.email}}</td>
          <td>
            <v-btn icon @click="editItem(props.item, props.index)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>
<script>
import { unixtimeToFormattedDate } from "@/utils/datetime.js";
import SimpleDatetimeInput from "@/components/common/simpleDatetimeInput.vue";
import SimpleDateInput from "@/components/common/simpleDateInput.vue";
export default {
  components: { SimpleDatetimeInput, SimpleDateInput },
  props: {
    contacts: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      headers: [
        { text: "種別", value: "toOrCc", sortable: false },
        { text: "名前", value: "name", sortable: false },
        { text: "アドレス", value: "email", sortable: false },
        { text: "操作", sortable: false }
      ],
      dialog: false,
      action: "update",
      selectedItem: {},
      newItem: { id: "", name: "" }
    };
  },
  mounted() {},
  methods: {
    updateItem() {
      this.$emit("updateItem", this.info);
    },
    editItem(item, index) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.selectedItem.index = index
      this.action = "update";
      this.dialog = true;
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(this.newItem));
      this.action = "add";
      this.dialog = true;
    },
    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete();
        this.reloadItems();
      } catch (e) {
        console.log(e);
      }
    },
    updateItem() {
      const i = this.selectedItem.index
      delete this.selectedItem['index']
      this.contacts[i]= this.selectedItem
      this.dialog = false
      
      this.$emit('updateItem')
    },
    createItem() {
      this.contacts.push(this.selectedItem)
      this.dialog = false
      
      this.$emit('updateItem')
    }
  },

};
</script>